import { defaultUserFormData } from '@atlas-frontend/sdk';
import { UserForm } from './UserForm';
import { path } from '../../paths';
import { useNavigateTo } from '../../paths/useNavigateTo';

export const UserCreate = () => {
  const navigateToUserDirectory = useNavigateTo(path.userDirectory);

  return (
    <UserForm
      mode="create"
      defaultValues={defaultUserFormData}
      onClickCancel={navigateToUserDirectory}
    />
  );
};
